import React, { useRef, useEffect, useState } from "react"
import PropTypes from "prop-types"
import Link from "gatsby-plugin-transition-link"
//import AniLink from "gatsby-plugin-transition-link/AniLink"
import TransitionLink from "gatsby-plugin-transition-link"
import styled from "styled-components"
import { motion, useAnimation } from "framer-motion"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import {
  useBoundingclientrect,
  useBoundingclientrectRef,
  useWindowSize,
} from "rooks"

import { navigate } from "gatsby"
import Image from "./image"
/****STYLES */

const GridImageStyles = styled.div`
  padding: 4vw;
  display: flex;
  align-items: center;
  justify-content: center;
`
const GridImageWrap = styled.div`
  width: 100%;

  @media (min-width: 768px) {
    width: 50vw;
    padding: 0;
  }
  @media (min-width: 1200px) {
    width: 30vw;
    padding: 0;
  }
`

/******STYLES */

export default function GridImage({
  image,
  id,
  selected,
  selectedOne,
  onChange,
  url,
}) {
  //stateof image
  const [isCenter, setIsCenter] = useState(false)
  const [isSelected, setIsSelected] = useState(true)
  const [initial, setInitial] = useState(true)
  //window
  const { innerWidth, innerHeight, outerHeight, outerWidth } = useWindowSize()
  const [scrollPosition, setScrollPosition] = useState(0)

  const handleScroll = () => {
    const position = window.pageYOffset
    setScrollPosition(position)
  }
  useEffect(() => {
    if (selected === "selected" || selectedOne === false) {
      setIsSelected(true)
    } else {
      setIsSelected(false)
    }
  })

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true })

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  /* NEW TRIAL */
  const gridRef = useRef(null)
  const gridRefZ = useRef(null)
  // X
  const [xPos, setX] = useState(null)

  // Y
  const [yPos, setY] = useState(null)

  //width
  const [width, setWidth] = useState(null)

  //height
  const [height, setHeight] = useState(null)

  //clicked
  const [clicked, setClicked] = useState(false)

  // This function calculate X and Y
  const getPosition = () => {
    if (!gridRef.current) return
    var viewportOffset = gridRef.current.getBoundingClientRect()

    const x = viewportOffset.left
    const width = viewportOffset.width

    setX(x)
    setWidth(width)

    const height = viewportOffset.height
    const y = viewportOffset.top

    setY(y)
    setHeight(height)
  }
  //show grid item
  const showContent = () => {
    gridRefZ.current.style.zIndex = "1001"
    setIsCenter(isCenter => "isCenter")
    //changeselected
    if (!clicked) {
      setClicked(!clicked)
      onChange(id)
      setClicked(true)

      setTimeout(
        () =>
          navigate(url, {
            state: image.asset.gatsbyImageData,
          }),
        700
      )
    }
    onChange(id)
  }

  // Get the position of the box
  useEffect(() => {
    getPosition()
    //(scrollPosition)
    const x = innerWidth * 0.5 - (xPos + width / 2)
    const y = innerHeight * 0.5 - (yPos + height / 2) + window.pageYOffset
  }, [])

  // Re-calculate X and Y of the red box when the window gets resized by the user
  useEffect(() => {
    window.addEventListener("resize", getPosition)
  }, [])

  //animation
  const variants = {
    isSelected: {
      opacity: 1,
    },
    isNotSelected: {
      opacity: 0,

      scale: 0.8,
    },
    isCenter: {
      opacity: 1,
      x: innerWidth * 0.5 - (xPos + width / 2),
      y: innerHeight * 0.5 - (yPos + height / 2) + scrollPosition,
      //  y: yPos,
    },

    offscreen: {
      opacity: 0,
    },
    onscreen: {
      opacity: 1,
      transition: {
        duration: 0.7,
      },
    },
  }

  return (
    <>
      <GridImageStyles
        key={id}
        as={motion.div}
        layout
        animate={[
          isCenter ? "isCenter" : "isNotCenter",
          isSelected ? "isSelected" : "isNotSelected",
        ]}
        transition={{ duration: 0.3, ease: [0.43, 0.13, 0.23, 0.96] }}
        variants={variants}
        whileTap={{ scale: 0.94 }}
        onClick={showContent}
        viewport={{
          once: false,
          amount: 0.1,
          margin: "2%",
        }}
        ref={gridRefZ}
      >
        <GridImageWrap ref={gridRef}>
          <Image image={image.asset.gatsbyImageData} />
        </GridImageWrap>
      </GridImageStyles>
    </>
  )
}
